import { CLOUDMAN, FISHMAN, GOLEM, INVADERS, LAVAMAN, ROBOTMAN, SANDMAN, TREEMAN, ZORG } from '@invaders/game';

/**
 * GDD section 2: team colours in order of arrival (red instead of the GDD's orange: the author's choice), then the
 * four of the teams 5 to 8 (up to 8 players: the author's choice).
 */
export const TEAM_COLORS = ['#ff4a3d', '#3fa0ff', '#5fd35f', '#ff6fb5', '#ff9a2e', '#a66bff', '#3fd6d0', '#f2e14c'] as const;
/** The names proposed for the teams (the author's choice): invaders' names, Zorg and Sandman first, then the GDD's order. */
export const DEFAULT_TEAM_NAMES: readonly string[] = [ZORG, SANDMAN, GOLEM, FISHMAN, LAVAMAN, TREEMAN, ROBOTMAN, CLOUDMAN].map((k) => INVADERS[k].name);
export const MAX_TEAM_NAME = 16;
